import { StatusDot } from "@/components/StatusDot";
import { sevdeskLink } from "./status";

/** `reachable`: sevDesk answered without warnings, so a missing name really means the contact is gone. */
export function SevdeskCell({ c, reachable, onLink }: { c: { sevdeskContactId: number | null; sevdeskName: string | null }; reachable: boolean; onLink: () => void }) {
  switch (sevdeskLink(c, reachable)) {
    case "unlinked":
      return (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onLink(); }}
          className="rounded-sm underline-offset-2 hover:underline focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-none"
        >
          <StatusDot tone="open">nicht verknüpft · verknüpfen</StatusDot>
        </button>
      );
    case "named":
      return <span className="block truncate" title={c.sevdeskName!}>{c.sevdeskName}</span>;
    case "missing":
      return <span className="text-destructive" title="Der verknüpfte Kontakt existiert in sevDesk nicht mehr">Kontakt {c.sevdeskContactId} fehlt</span>;
    case "unknown":
      return <span className="text-muted-foreground">sevDesk #{c.sevdeskContactId}</span>;
  }
}
